import React, { useState } from 'react';
import './NewsletterForm.css';

function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false); // 🌀 loading state

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setEmailError('Please enter a valid email address.');
      setIsSuccess(false);
      setMessage('');
      return;
    }

    setEmailError('');
    setMessage('');
    setIsSuccess(false);
    setIsLoading(true); // 🔄 Start loading
    try {
      const response = await fetch('https://webvexo.com/new_sub_web_mail.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const result = await response.json();

      if (response.ok) {
        setIsSuccess(true);
        setMessage('Thanks for subscribing! Please check your email for confirmation.');
        setEmail('');
      } else {
        setIsSuccess(false);
        setMessage(result.message || 'Something went wrong.');
      }
    } catch (error) {
      console.error('Error:', error);
      setIsSuccess(false);
      setMessage('Network error. Please try again later.');
    }
    finally {
    setIsLoading(false); // ✅ Ensure loading always ends
    }
  };
  return (
    <div className='container mt-5 pt-5' data-aos="zoom-in" data-aos-delay="400">
      <div className='row bg-color-yellow'>
        <div className='col-md-5 mt-5'>
          <p className='fs-2 fw-bold mb-1'>Subscribe To Newsletter</p>
        </div>
        <div className='col-md-6'>
            <form onSubmit={handleSubmit} className='NewsletterForm'>
              <div className="form-group mb-2">
                <input type="email" name="email" value={email} onChange={(e) => {
                    setEmail(e.target.value);
                    setEmailError('');
                    setMessage('');
                  }}
                  className={`form-control ${emailError ? 'input-error' : ''}`}
                  placeholder="Enter your email"
                />
                {emailError && <small className="text-danger">{emailError}</small>}
                <button type="submit" className="insuba-btn btn color" disabled={isLoading}>
                  {isLoading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" />
                      Submitting...
                    </>
                  ) : (
                    'Subscribe Now'
                  )}
                </button>
              </div>
              {message && (
                <p className={`mt-3 fs-5 ${isSuccess ? 'text-success' : 'text-danger'}`}>{message}</p>
              )}
            </form>
        </div>
      </div>
     
      
    </div>
  );
}



export default NewsletterForm;
